import * as Anuto from "../../../../../engine/src";
import { BattleManager } from "../../BattleManager";
import { GameVars } from "../../../../GameVars";

export class UpgradeButton extends Phaser.GameObjects.Container {

    private anutoTurret: Anuto.Turret;
    private btn: Phaser.GameObjects.Image;
    private txtPrice: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene, x: number, y: number) {

        super(scene);

        this.x = x;
        this.y = y;

        this.btn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_upgrade_turret");
        this.btn.setInteractive();
        this.btn.on("pointerup", () => { this.onClickBtn(); });
        this.add(this.btn);

        this.txtPrice = new Phaser.GameObjects.Text(this.scene, 0, 18, "", {fontFamily: "Rubik-Bold", fontSize: "18px", color: "#ffffff", align: "center"});
        this.txtPrice.setOrigin(.5);
        this.txtPrice.setStroke("#000000", 4);
        this.add(this.txtPrice);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (!this.anutoTurret) {
            return;
        }

        this.updateInfo();
    }

    public updateInfo(anutoTurret?: Anuto.Turret): void {
        
        if (anutoTurret) {
            this.anutoTurret = anutoTurret;
        }

        if (this.anutoTurret.level === this.anutoTurret.maxLevel) {
            this.btn.setFrame("btn_locked");
            this.btn.alpha = 1;
            this.txtPrice.visible = false;
        } else if (this.anutoTurret.level < this.anutoTurret.maxLevel) {
            if (this.anutoTurret.level >= GameVars.gameData.upgradesUnlocked[this.anutoTurret.type]) {
                this.btn.setFrame("btn_locked");
                this.btn.alpha = 1;
                this.txtPrice.visible = false;
            } else if (this.anutoTurret.priceUpgrade > BattleManager.anutoEngine.credits) {
                this.btn.setFrame("btn_upgrade_turret");
                this.btn.alpha = .5;
                this.txtPrice.visible = true;
            } else {
                this.btn.setFrame("btn_upgrade_turret");
                this.btn.alpha = 1;
                this.txtPrice.visible = true;
            }
        }   

        this.txtPrice.setText(this.anutoTurret.priceUpgrade.toString());
    }

    private onClickBtn(): void {

        if (!this.txtPrice.visible) {
            return;
        }
        
        BattleManager.upgradeTurret(this.anutoTurret.id);
    }
}
